import * as apiGetReportDetails from "@/api/cockpit/powerBI/getReportDetails.js";

import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        reportDetails: {}
    },
    mutations: {
        gotReportDetails(state, details) {
            state.reportDetails = JSON.parse(details)
        },

        isLoading(state, loading) {
            state.loading = loading;
        },

    },
    actions: {
        async getReportDetails({ commit }, { reportId, workspaceId }) {
            commit("isLoading", true);

            const result = await apiGetReportDetails.get(reportId, workspaceId);

            if (result) {
                commit("gotReportDetails", result);
            }

            commit("isLoading", false);
        },

    },
    getters: {
        reportDetails: state => state.reportDetails,
    }
};
